<ng-template #dialogTemplate>
  <div
    class="phx-dialog-container"
    [@dialogAnimation]="{
      value: animationState,
      params: {
        orientation: animationOrientation,
        translation: animationTranslation,
        scalingFactor: animationScalingFactor
      }
    }"
    (@dialogAnimation.done)="onAnimationEnd($event)"
    (keydown)="this.phxKeydown.emit($event)"
    tabindex="-1"
  >
    <ng-content></ng-content>
  </div>
</ng-template>
